import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { MainMenuRegionalDisplay } from '../components/MainMenuRegionalDisplay';

export const MainMenuRegionalDisplayProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <MainMenuRegionalDisplay {...data} />
        </Provider>
    );
};

MainMenuRegionalDisplayProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
